export default /* glsl */`
vec2 getUv1() {
    return vertex_texCoord1;
}
`;
